/* eslint-disable no-loop-func */

import React, { Component } from 'react';
import { Button } from 'reactstrap';
import HeaderComponent from "../../../components/header/HeaderComponent";
import ErrorComponent from '../../../components/error/ErrorComponent';
import LoadingComponent from '../../../components/loading/LoadingComponent';
import RotaViewTableRow from "./RotaViewTableRow";
import RotaViewTableHeader from "./RotaViewTableHeader";
import { LuChevronRight, LuChevronLeft, LuRefreshCw } from "react-icons/lu";
import { BiSearch } from "react-icons/bi";
import InputTextComponent from "../../../components/forms/InputTextComponent";

const stringUtil = require('../../../utils/string/stringUtil');
const dateUtil = require('../../../utils/dateUtil/dateUtil');
const staffUtility = require('../../../utils/domain/staff/staffUtility');
const rmsApiProxyRetry = require('../../../utils/api/rmsApiProxyRetry');
const logger = require('../../../utils/logger/logger');
const stateManager = require('../../../utils/state/stateManager');
const translator = require('../../../utils/translator/translator');

var screenKeyboardAction = require('../../../utils/state/actions/views/onScreenKeyboard/screenKeyboardAction');
var navigationPageAction = require('../../../utils/state/actions/views/navigationPage/navigationPageAction');

const arraySort = require('array-sort');

const noOfDaysInAdvancedForRota = 30;
const noOfDaysToDisplayForRota = 7;

class RotaView extends Component 
{

    constructor(props)
    {
        super(props);

        this.renderError = this.renderError.bind(this);
        this.renderSearchingBody = this.renderSearchingBody.bind(this);
        this.getRotaStaffs = this.getRotaStaffs.bind(this);
        this.getRotaDates = this.getRotaDates.bind(this);

        this.onRefreshButton = this.onRefreshButton.bind(this);

        this.state = {};
        this.state.stage = 'searching';
        this.state.error = null;

        this.state.searchText = "";
        this.state.index = 0;

        this.state.rotaStaffs = [];
        this.state.rotaDates = [];
    }

    render()
    {
        return  <div className='h-100'>
                    {this.renderToolbar()}

                    {
                        (!stringUtil.isStringNullOrEmpty(this.state.error)) ?
                            this.renderError() :

                            (this.state.stage === 'searching') ?
                                this.renderSearchingBody() :

                                (this.state.stage === 'loaded') ?
                                    <div style={{height:'90vh', overflowY:'auto'}}>
                                        <RenderRotaBody searchText={this.state.searchText} rotaStaffs={this.state.rotaStaffs} rotas={this.state.rotas} endDate={this.state.endDate} fromDate={this.state.fromDate} rotaDates={this.state.rotaDates} index={this.state.index} /> 
                                    </div>  :
                                    null
                    }

                </div>;
    }

    renderToolbar()
    {
        let isDisabled = stringUtil.areStringSame(this.state.stage, 'searching') 
                            || this.state.error != null 
                            
        let isSearchDisabled = isDisabled
                                || !this.state.rotaStaffs 
                                || this.state.rotaStaffs.length <= 1;

        return  <HeaderComponent title={this.props.title}>
                    <table style={{width:'100%'}}>
                        <tr>
                            <td style={{width:'80%', whiteSpace:'nowrap'}}>
                                <div style={{marginRight:'10px'}}>
                                    <InputTextComponent 
                                        style={{height:'var(--button-height)'}} 
                                        disabled={isSearchDisabled} 
                                        placeholder={
                                            <span> 
                                                <BiSearch /> {translator.getLabel("search")}
                                            </span>
                                        }
                                        value={this.state.searchText}
                                        inputTextType="text"
                                        onValueChange={(value)=>
                                            {
                                                this.state.searchText = value;
                                                this.setState({});
                                            }}/>
                                </div>
                            </td>

                            <td>
                                <div style={{marginRight:'70px'}}>
                                    <Button 
                                        className='btn-action' 
                                        disabled={isDisabled} 
                                        style={{minWidth:'5vw', height: 'calc(3.5rem + calc(var(--bs-border-width) * 2))', minHeight: 'calc(3.5rem + calc(var(--bs-border-width) * 2))'}}
                                        onClick={() => 
                                            {
                                                logger.usage("Rota.Refresh", "Staff clicked refresh button to refresh rota");
                                                this.onRefreshButton();
                                            }}>
                                        <LuRefreshCw/>
                                    </Button>
                                </div>
                            </td>

                            <td>
                                <div style={{marginRight:'5px'}}>
                                    <Button 
                                        className="btn-action" 
                                        disabled={this.state.index === 0} 
                                        style={{minWidth:'5vw', height: 'calc(3.5rem + calc(var(--bs-border-width) * 2))', minHeight: 'calc(3.5rem + calc(var(--bs-border-width) * 2))'}}
                                        onClick={()=>
                                        {
                                            logger.usage("Rota.Previous", "Staff clicked previous button to see previous rota");
                                
                                            if(this.state.index > 0)
                                            {
                                                this.state.index = this.state.index - 1;
                                                this.setState({});
                                            }
                                        }}>
                                        <LuChevronLeft style={{fontSize: '2.5rem'}}/>
                                    </Button>
                                </div>
                            </td>
                            <td>
                                <div style={{marginRight:'70px'}}>
                                    <Button 
                                        className="btn-action" 
                                        disabled={this.state.rotaDates.length < noOfDaysToDisplayForRota || this.state.index + noOfDaysToDisplayForRota === this.state.rotaDates.length} 
                                        style={{minWidth:'5vw', height: 'calc(3.5rem + calc(var(--bs-border-width) * 2))', minHeight: 'calc(3.5rem + calc(var(--bs-border-width) * 2))'}}
                                        onClick={()=>
                                        {
                                            logger.usage("Rota.Next", "Staff clicked next button to see more rota");
                                            if(this.state.index < this.state.rotaDates.length + noOfDaysToDisplayForRota)
                                            {
                                                this.state.index = this.state.index + 1;
                                                this.setState({});
                                            }
                                        }} >
                                        <LuChevronRight style={{fontSize: '2.5rem'}}/>
                                    </Button>
                                </div>
                            </td>

                            <td style={{whiteSpace:'nowrap'}}>
                                <Button 
                                    className='btn-cancel'
                                    style={{height: 'calc(3.5rem + calc(var(--bs-border-width) * 2))', minHeight: 'calc(3.5rem + calc(var(--bs-border-width) * 2))'}}
                                    onClick={()=>
                                        {
                                            logger.usage("RotaView.Exit", "Staff clicked exit button to exit RotaView");
                                            this.state.unmounted = true;
                                            stateManager.getStore().dispatch(screenKeyboardAction.createAction(null));
                                            stateManager.getStore().dispatch(navigationPageAction.createAction(null))
                                        }}>{translator.getLabel("exit")}
                                </Button>
                            </td>

                            
                        </tr>
                    </table>
                </HeaderComponent>
    }

    renderError()
    {
        return  <div className='h-50 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                    <ErrorComponent error={this.state.error}/>
                </div>
    }

    renderSearchingBody()
    {
        this.state.error = null;
        this.state.rotas = null;

        this.state.fromDate = dateUtil.getToday();
        this.state.endDate = dateUtil.addDays(this.state.fromDate, noOfDaysInAdvancedForRota);

        var rotaResourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/hr/rota?start=${this.state.fromDate}&end=${this.state.endDate}`;
        rmsApiProxyRetry.get(rotaResourceUrl)
            .then(results =>
            {
                if (results == null)
                    results = [];

                this.state.rotas = this.filterRawRota(results);
                this.state.rotaStaffs = this.getRotaStaffs();
                this.state.rotaDates = this.getRotaDates();

                this.state.stage = 'loaded';
                this.setState({});
            }, error =>
            {
                this.state.error = error;
                this.setState({});
            });


        return this.showLoader();
    }

    showLoader()
    {
        return  <div className='h-50 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                    <LoadingComponent waitMessage={translator.getLabel("please_wait_loading_rota")}/>
                </div>
    }

    filterRawRota(rawRotas)
    {
        var filteredRotas = [];

        rawRotas.forEach(rawRota =>
        {
            if (rawRota.isDraft)
                return;

            filteredRotas.push(rawRota);
        });

        return filteredRotas;
    }

    getRotaStaffs()
    {
        var rotaStaffs = [];

        if (this.state.rotas == null || this.state.rotas.length <= 0) return [];

        this.state.rotas.forEach(rota =>
        {
            if (rotaStaffs.some(rs => rs.staffId === rota.staffId))
                return;

            var staff = staffUtility.getAllStaff().find(s => s.id === rota.staffId);
            if (staff == null)
                return;

            var rotaStaff = {};
            rotaStaff.staffId = rota.staffId;
            rotaStaff.name = staffUtility.getStaffCompleteName(staff);
            rotaStaff.pictUrl = staff.pictUrl;
            rotaStaffs.push(rotaStaff);
        });

        return arraySort(rotaStaffs, "name");
    }

    getRotaDates()
    {
        let fromDate = this.state.fromDate;
        let endDate = this.state.endDate;
        let rotas = this.state.rotas;

        var rotaDates = [];

        var rotaFoundForDate = endDate;

        while (rotaFoundForDate >= fromDate)
        {
            var allRotasForDate = [];

            rotas.forEach(rota =>
            {
                if (!dateUtil.isDateComponentSame(rota.start, rotaFoundForDate))
                    return;

                    allRotasForDate.push(rota);
            });

            if (allRotasForDate.length > 0)
            {
                rotaDates.push(rotaFoundForDate);
            }

            rotaFoundForDate = dateUtil.subtractDays(rotaFoundForDate, 1);
        }

        return rotaDates;
    }

    getAllRotasForDate(date)
    {
        var dateRotas = [];
        this.state.rotas.forEach(rota =>
        {
            if (!dateUtil.isDateComponentSame(rota.start, date))
                return;

            dateRotas.push(rota);
        });
        return dateRotas;
    }

    onRefreshButton()
    {
        this.state.stage = 'searching';
        this.setState({});
    }
}

export default RotaView;

const RenderRotaBody = ({rotaStaffs, searchText, endDate, fromDate, rotas, rotaDates, index}) =>
{
    if (!stringUtil.isStringNullOrEmpty(searchText))
    {
        searchText = stringUtil.trimString(searchText);
        rotaStaffs = rotaStaffs.filter(staff => staff.name.toLowerCase().includes(searchText.toLowerCase()))
    }

    if (rotaStaffs == null || rotaStaffs.length <= 0)
    {
        return  <div className='h-50 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                    <ErrorComponent error={"No rota found!"}/>
                </div>
    }
    
    rotaDates = arraySort(rotaDates);

    let rotaDatesForPeriod = rotaDates.slice(index, index + noOfDaysToDisplayForRota);

    return <div style={{ position: 'relative', overflow: 'auto', whiteSpace: 'nowrap' }}>
        <table class="pure-table pure-table-bordered" width='100%'>
            <thead style={{ background: '#FFFFFF' }}>
                <RotaViewTableHeader endDate={endDate} fromDate={fromDate} rotaDates={rotaDatesForPeriod} />
            </thead>
            <tbody>
                {
                    rotaStaffs.map((rotaStaff) => 
                    (
                        <RotaViewTableRow key={rotaStaff.staffId} rotaDates={rotaDatesForPeriod} endDate={endDate} fromDate={fromDate} rotas={rotas} rotaStaff={rotaStaff} />
                    ))
                }
            </tbody>
        </table>
    </div>
}